const POLL_INTERVAL = 250;
const DEFAULT_TIMEOUT = 15000;

/**
 * Intercom is loaded asynchronously as a Segment destination, so `window.Intercom`
 * usually does not exist yet right after `analytics.identify()`.
 * Waits until the messenger is loaded and booted.
 *
 * @returns true once Intercom is booted – false if the timeout kicks in.
 */
export const waitForIntercom = (timeout: number = DEFAULT_TIMEOUT): Promise<boolean> =>
  new Promise((resolve) => {
    const startedAt = Date.now();

    const check = () => {
      if (window.Intercom && window.Intercom.booted) {
        resolve(true);

        return;
      }

      if (Date.now() - startedAt >= timeout) {
        resolve(false);

        return;
      }

      window.setTimeout(check, POLL_INTERVAL);
    };

    check();
  });
